<template>
  <DropdownData
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :serviceFunction="fetchData"
    placeholder="Seleccione un Tipo de Merma..."
    :disabled="disabled"
  />
</template>

<script>
import DropdownData from './DropdownData.vue';
import TipoMermaService from '@/service/TipoMermaService';

export default {
  name: 'DropdownTipoMerma',
  components: {
    DropdownData
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.tipoMermaService = new TipoMermaService();
  },
  methods: {
    fetchData() {
      return this.tipoMermaService.getTipoMermaCombo();
    }
  }
}
</script>
